import { Module } from "vuex";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { StageConfigState } from "./types";
import { RootState } from "../../types";

export const state: StageConfigState = {
  stage: "",
  auth0Domain: undefined,
  auth0ClientId: undefined,
  auth0Audience: undefined,
  auth0RedirectUri: undefined,
  exchangeAPIUrl: undefined,
  graphqlBase: undefined,
  renderBase: undefined,
  profileUrl: undefined,
  appURL: undefined,
  features: undefined
};

const namespaced: boolean = true;

export const stageConfig: Module<StageConfigState, RootState> = {
  namespaced,
  state,
  actions,
  mutations
};

export default {
  namespaced: true
};
